import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "help-container mobilefixhelp" }

import { Ref, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpPopup',
  props: {
  msg: {
    type: String,
    default: "",
  },
  helpClass: {
    type: String,
    default: "help",
  },
},
  setup(__props) {

const props = __props;


const showPopup: Ref<boolean> = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(__props.helpClass),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showPopup.value = true))
    }, "?", 2),
    _createElementVNode("div", {
      class: "help-content",
      style: _normalizeStyle(showPopup.value ? 'display:inline-block' : 'display:none')
    }, [
      _createElementVNode("span", {
        class: "close",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (showPopup.value = false))
      }, "x"),
      _createTextVNode(" " + _toDisplayString(__props.msg), 1)
    ], 4)
  ]))
}
}

})